import NavigationItem from "./NavigationItem";
import type { NavItemType } from "./NavigationItem";
import ncNanoId from "utils/ncNanoId";
import { useTranslation } from "react-i18next";

function Navigation() {

  const { t, ready } = useTranslation("translation");

  if (!ready) return null;

  let navigationItems = t("translation:navbar.navigation", { returnObjects: true }) as NavItemType[];
  navigationItems = navigationItems.filter((item) => item.hideOnDesktop? false : true).map(
    (item: NavItemType) => {
      return {
        ...item,
        id: ncNanoId(),
      };
    }
  );

  return (
    <ul className="nc-Navigation hidden lg:flex lg:flex-wrap lg:items-center lg:space-x-1 relative">
      {navigationItems.map((item) => (
        <NavigationItem 
          key={item.id} 
          menuItem={item} 
        />
      ))}
    </ul>
  );

}

export default Navigation;
